import type { FullActivityItem } from '@customTypes/types';
import { Badge, Box, Stack, Text } from '@mantine/core';

export const BoardCol = ({
  colTitle,
  data,
  onSelectItem,
  renderItem: RenderItem
}: {
  colTitle: string;
  data: FullActivityItem[];
  onSelectItem: (activityItem: FullActivityItem) => void;
  renderItem: React.ComponentType<{
    task: FullActivityItem;
    onClick: () => void;
  }>;
}) => (
  <Stack
    gap='md'
    style={{
      padding: '20px',
      borderRadius: '12px',
      backgroundColor: 'rgba(255, 255, 255, 0.75)',
      backdropFilter: 'blur(10px)',
      border: '1px solid rgba(255, 255, 255, 0.5)',
      minWidth: '280px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.05)'
    }}
  >
    <Box>
      <Badge
        color='blue'
        size='lg'
        variant='light'
        styles={{
          label: {
            textTransform: 'capitalize',
            fontSize: '14px',
            fontWeight: 600
          }
        }}
      >
        {colTitle}
      </Badge>
      <Text c='dimmed' mt={4} size='xs'>
        {data.length} {data.length === 1 ? 'item' : 'items'}
      </Text>
    </Box>
    <Stack gap='sm'>
      {data.map((item: FullActivityItem, index) => (
        <RenderItem
          key={index}
          task={item}
          onClick={() => onSelectItem(item)}
        />
      ))}
    </Stack>
  </Stack>
);
